import { createFileRoute } from "@tanstack/react-router"
import {
	enforceSignupStep,
	getOnboardingFormValues,
} from "@/features/registration-workflow"
import { SignupGenderPage } from "@/pages/onboarding"

export const Route = createFileRoute("/onboarding/signup-gender")({
	beforeLoad: () => {
		enforceSignupStep("gender")
		return { firstName: getOnboardingFormValues()?.firstName ?? "" }
	},
	component: SignupGenderPage,
})
